import { DataTableColumn, ColumnSet } from '../model/DataTableColumn'
import i18n from '@/i18n'
import { sortDestinationQuotas } from '../utils/SortHelpers'

export default {
  quotaContractHeaders () {
    const columns = [
      new DataTableColumn({
        id: 0,
        sortable: false,
        text: i18n.t('status'),
        value: 'status',
        align: 'center',
        hidable: false
      }),
      new DataTableColumn({
        id: 1,
        sortable: true,
        text: i18n.t('tract'),
        value: 'tract',
        hidable: false
      }),
      new DataTableColumn({
        id: 2,
        sortable: true,
        text: i18n.t('logger'),
        value: 'logger'
      }),
      new DataTableColumn({
        id: 3,
        sortable: true,
        text: i18n.t('setting'),
        value: 'setting',
        hidable: false
      }),
      new DataTableColumn({
        id: 4,
        sortable: true,
        text: i18n.t('forester'),
        value: 'forester',
        hidable: false
      }),
      new DataTableColumn({
        id: 5,
        sortable: true,
        text: i18n.t('created'),
        value: 'quotaContractCount',
        align: 'right',
        hidable: false
      }),
      new DataTableColumn({
        id: 6,
        sortable: false,
        text: i18n.t('related'),
        value: 'related',
        width: '10',
        align: 'center',
        hidable: false
      }),
      new DataTableColumn({
        id: 7,
        sortable: false,
        text: i18n.t('actions'),
        value: 'actions',
        align: 'center',
        hidable: false
      })
    ]
    return new ColumnSet({
      columns: columns,
      setName: 'QuotaHeaders'
    })
  },

  quotaDestinationHeaders () {
    const columns = [
      new DataTableColumn({
        id: 0,
        sortable: true,
        text: i18n.t('destination'),
        value: 'name',
        hidable: false
      }),
      new DataTableColumn({
        id: 1,
        sortable: true,
        text: i18n.t('allocated'),
        align: 'right',
        value: 'quotaAssignedToDestination',
        hidable: false
      }),
      new DataTableColumn({
        id: 2,
        sortable: true,
        text: i18n.t('created'),
        align: 'center',
        sort: sortDestinationQuotas,
        value: 'quotaAssignedCreated',
        hidable: false
      })
    ]
    return new ColumnSet({
      columns: columns,
      setName: 'QuotaHeaders'
    })
  },

  quotaDialogHeaders () {
    const columns = [
      new DataTableColumn({
        id: 0,
        sortable: true,
        text: i18n.t('contractAccount'),
        value: 'name',
        hidable: false
      }),
      new DataTableColumn({
        id: 1,
        sortable: true,
        text: i18n.t('allocated'),
        value: 'quotaInEffect',
        align: 'right',
        hidable: false,
        tooltip: i18n.t('quotaAllocatedToCurrent')
      }),
      new DataTableColumn({
        id: 2,
        sortable: true,
        text: i18n.t('planned'),
        value: 'quotaNextPeriod',
        align: 'right',
        hidable: false,
        tooltip: i18n.t('quotaPlannedForNext')
      }),
      new DataTableColumn({
        id: 3,
        sortable: true,
        text: i18n.t('created'),
        value: 'quotaCurrentCount',
        align: 'right',
        hidable: false
      }),
      new DataTableColumn({
        id: 4,
        sortable: true,
        text: i18n.t('remaining'),
        value: 'quotaRemaining',
        align: 'right',
        hidable: false
      })
    ]
    return new ColumnSet({
      columns: columns,
      setName: 'QuotaHeaders'
    })
  }
}
